import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore/lite";
import { utils } from "@core/helper";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Loading from "./loading";
import { Container, Row, Col } from "react-bootstrap";
// import FormModal from "./consult";
import PhoneInput from "react-phone-input-2";
import { collectionKeys } from "@core/helper/utils";
import TalkToUsNew from "./talk-to-us-new";

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const validationSchema = Yup.object().shape({
  name: Yup.string().label("Name").required(),
  email: Yup.string()
    .label("Email")
    .matches(emailRegex, "Invalid email address")
    .required(),
  mobile: Yup.string().label("Contact").required(),
  country: Yup.string().label("Country").optional(),

  service: Yup.string().label("Service").required(),
  content: Yup.string().label("Content").required(),
});

const MoveForward = (props) => {
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  // const [consultantShow, setConsultantShow] = React.useState(false);

  // const handleConsultantTogg = () => {
  //   setConsultantShow(!consultantShow);
  // };

  const { db } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    criteriaMode: "firstError",
  });
  const handleOnchange = (value, country) => {
    setValue("country", country.countryCode, { shouldValidate: true });
    setValue("mobile", value, { shouldValidate: true });
    setPhone(value);
  };

  const handleOnSubmit = async (values) => {
    const { name, email, country, content, mobile, service } = values;
    const payload = {
      name,
      email,
      country,
      content,
      mobile,
      service,
      date: new Date(),
      status: true,
      type: "",
    };

    setLoading(true);
    try {
      // return false
      const clients = collection(db, collectionKeys.CLIENTS);
      await addDoc(clients, payload);
      utils.showSuccssMsg("We will contact/talk to you soon");
      reset();
      setPhone("91");
      setValue("country", "in", { shouldValidate: true });
      setLoading(false);
    } catch (e) {
      utils.showErrMsg("Error adding document");
      setLoading(false);
    }
  };

  return (
    <section className="justtry_cta_sec">
      <Container>
        <div className="d-flex align-items-center justify-content-center">
          <Row className="justtry_cta_form_wrapper">
            <Col
              xxl={7}
              xl={6}
              lg={6}
              md={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="justtry_cta_form_sec">
                <h2 className="text-dark">
                  Get in <span style={{ color: "#7534fc" }}>Touch</span>
                </h2>
                <p>
                  We're available to assist and address any inquiries you may
                  have. We eagerly anticipate receiving your communication.
                </p>
                <form
                  onSubmit={handleSubmit(handleOnSubmit)}
                  className="justtry_cta_form"
                >
                  <div className="justtry_cta_form_content">
                    <div className="justtry_cta_form_lhs">
                      <input
                        placeholder="Enter your name"
                        id="full-name"
                        type="text"
                        {...register("name")}
                        maxLength={30}
                      />
                      <span className="error_msg_text">
                        {errors.name?.message}
                      </span>
                    </div>
                    <div className="justtry_cta_form_rhs">
                      <input
                        placeholder="Enter your mail"
                        id="email"
                        type="email"
                        {...register("email")}
                        maxLength={50}
                      />
                      <span className="error_msg_text">
                        {errors.email?.message}
                      </span>
                    </div>
                  </div>
                  <div className="justtry_cta_form_phone">
                    <PhoneInput
                      className="phone_input"
                      country={"in"}
                      value={phone}
                      enableSearch
                      searchPlaceholder=""
                      // {...register("mobile")}
                      onChange={handleOnchange}
                      placeholder="Enter your number"
                    />
                    <span className="error_msg_text">
                      {errors?.mobile?.message}
                    </span>
                  </div>

                  <div className="justtry_cta_form_service">
                    <select {...register("service")} className="classic" aria-label="state">
                      <option value="Select your services">
                        Select your services
                      </option>
                      <option value="crypto exchange development">
                        Crypto Exchange Development
                      </option>
                      <option value="nft marketplace development">
                        NFT Marketplace Development
                      </option>
                      <option value="defi development">DeFi Development</option>
                      <option value="metaverse development">
                        Metaverse Development
                      </option>
                      <option value="blockchain solutions">
                        Blockchain Solutions
                      </option>
                      <option value="web 3.0 development">
                        Web 3.0 Development
                      </option>
                      <option value="crypto wallet development">
                        Crypto Wallet Development
                      </option>
                      <option value="custom software development">
                        Custom Software Development
                      </option>
                      <option value="mobile app development services">
                        Mobile App Development Services
                      </option>
                      <option value="artificial intelligence solutions">
                        Artificial Intelligence Solutions
                      </option>
                      <option value="others"> Others</option>
                    </select>
                    <span className="error_msg_text">
                      {errors.service?.message}
                    </span>
                  </div>
                  <div className="justtry_cta_textarea">
                    <textarea
                      placeholder="Text your message here..."
                      id="content"
                      rows={5}
                      {...register("content")}
                    />
                    <span className="error_msg_text">
                      {errors.content?.message}
                    </span>
                  </div>
                  <div className="justtry_cta_sumbit">
                    <button
                      className="form_submit_btn"
                      disabled={loading}
                      type="submit"
                    >
                      Submit Now {loading && <Loading />}
                    </button>
                    {/* <button
                      className="form_consult_btn"
                      onClick={handleConsultantTogg}
                      type="button"
                    >
                      Free consult
                    </button> */}
                    <button
                      className="form_consult_btn"
                      type="button"
                    >
                      <TalkToUsNew label="Free Consult" db={db} />
                    </button>
                  </div>
                </form>
                {/* <FormModal
                  onAddProps={props}
                  show={consultantShow}
                  onHide={handleConsultantTogg}
                /> */}
              </div>
            </Col>
            <Col
              xxl={5}
              xl={6}
              lg={6}
              md={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="justtry_cta_map_sec">
                <iframe
                  title="Justtry Office"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.2126470840517!2d78.1340045741623!3d9.916240074472167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c539e6118b11%3A0x6c3891e5d1526c93!2sJusttry%20Technologies!5e0!3m2!1sen!2sin!4v1694181975876!5m2!1sen!2sin"
                  className="map_frame"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default MoveForward;
